import {useGetUserDancesQuery, useI18n} from 'store/Store'

const useMyDances = () => {
    const {i18n} = useI18n()
    const {data: myDances, isLoading} = useGetUserDancesQuery()

    const translationLabel = 'myDances.'
    const t = (label, input) => i18n.t(translationLabel + label, input)

    return {
        myDances,
        isLoading,
        t,
    }
}

export default useMyDances
